module.exports = __webpack_public_path__ + "img/decimmo_banner.f084924f.png";